// Centralized API base URL for the frontend.
// CRA reads environment variables that start with `REACT_APP_`.
const API_BASE_URL = "https://ee-predictor-backend.onrender.com";
export default API_BASE_URL;

